module.exports = __webpack_public_path__ + "img/sol_isol_pain4.c799c83d.png";